"use strict";
/*
  sort.ts
  Marc-Antoine Deragon's box sorting implementation for the doosan
  cobot palletizer.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.marcSort = exports.BoxSort = void 0;
function FirstCondition(x1, x2, y1, y2, side) {
    if (x1 < x2 &&
        y1 < y2 &&
        Math.abs(x1 - x2) > 1 &&
        Math.abs(y1 - y2) > 1 &&
        side == 'left') {
        return true;
    }
    if (x1 > x2 &&
        y1 < y2 &&
        Math.abs(x1 - x2) > 1 &&
        Math.abs(y1 - y2) > 1 &&
        side == 'right') {
        return true;
    }
    return false;
}
function SecondCondition(x1, x2, x3, x4, y1, y2) {
    if (Math.abs(x1 - x3) < 1 && Math.abs(x2 - x4) < 1 && y1 < y2) {
        return true;
    }
    return false;
}
function ThirdCondition(y1, y2, y3, y4, x1, x2, side) {
    if (Math.abs(y1 - y3) < 1 &&
        Math.abs(y2 - y4) < 1 &&
        x1 < x2 &&
        side == 'left') {
        return true;
    }
    if (Math.abs(y1 - y3) < 1 &&
        Math.abs(y2 - y4) < 1 &&
        x1 > x2 &&
        side == 'right') {
        return true;
    }
    return false;
}
function FourthCondition(x1, x2, x3, side) {
    if (x1 <= x2 && x1 <= x3 && side == 'left') {
        return true;
    }
    if (x1 >= x2 && x1 >= x3 && side == 'right') {
        return true;
    }
    return false;
}
function BoolIndex(arr) {
    let indicesFalse = [];
    let indicesTrue = [];
    //Finding index of !rotated
    let idx = arr.indexOf(false);
    while (idx != -1) {
        indicesFalse.push(idx);
        idx = arr.indexOf(false, idx + 1);
    }
    //Finding index of rotated
    idx = arr.indexOf(true);
    while (idx != -1) {
        indicesTrue.push(idx);
        idx = arr.indexOf(true, idx + 1);
    }
    return [indicesTrue, indicesFalse];
}
function BoxSort(x, y, r, s, multiPick, multipickAlongWidth, boxWidth, boxLength, palletWidth, palletLength, side) {
    // Changing frame for bottom left
    y = y.map(function (item) {
        return Math.floor((1 - item) * palletLength);
    });
    if (side == 'right') {
        x = x.map(function (item) {
            return item - 1;
        });
    }
    x = x.map(function (item) {
        return Math.floor(item * palletWidth);
    });
    //Finding rotated and !rotated pos index
    let [indicesTrue, indicesFalse] = BoolIndex(r);
    let minX = x.slice();
    let maxX = x.slice();
    let minY = y.slice();
    let maxY = y.slice();
    if (side == 'left') {
        //Finding each boxes max X and max Y
        indicesFalse.forEach(function (val) {
            if (multipickAlongWidth[val]) {
                maxX[val] += (multiPick[val] + 1) * boxWidth;
                minY[val] -= boxLength;
            }
            else {
                maxX[val] += boxWidth;
                minY[val] -= (multiPick[val] + 1) * boxLength;
            }
        });
        indicesTrue.forEach(function (val) {
            if (multipickAlongWidth[val]) {
                maxX[val] += boxLength;
                minY[val] -= (multiPick[val] + 1) * boxWidth;
            }
            else {
                maxX[val] += (multiPick[val] + 1) * boxLength;
                minY[val] -= boxWidth;
            }
        });
    }
    if (side == 'right') {
        indicesFalse.forEach(function (val) {
            if (multipickAlongWidth[val]) {
                minX[val] += (multiPick[val] + 1) * boxWidth;
                minY[val] -= boxLength;
            }
            else {
                minX[val] += boxWidth;
                minY[val] -= (multiPick[val] + 1) * boxLength;
            }
        });
        indicesTrue.forEach(function (val) {
            if (multipickAlongWidth[val]) {
                minX[val] += boxLength;
                minY[val] -= (multiPick[val] + 1) * boxWidth;
            }
            else {
                minX[val] += (multiPick[val] + 1) * boxLength;
                minY[val] -= boxWidth;
            }
        });
    }
    let swapped = true;
    let loopCount = 0;
    let maxLoop = 10000;
    let nextPoint;
    do {
        swapped = false;
        loopCount++;
        for (let i = 0; i < x.length; i++) {
            for (let j = i; j < x.length; j++) {
                if (i < x.length - 1) {
                    nextPoint = minX[i + 1];
                }
                else {
                    if (side == 'right') {
                        nextPoint = 2;
                    }
                    else {
                        nextPoint = -1;
                    }
                }
                if ((FirstCondition(minX[i], maxX[j], minY[i], maxY[j], side) ||
                    SecondCondition(maxX[i], minX[i], maxX[j], minX[j], y[i], y[j]) ||
                    ThirdCondition(maxY[i], minY[i], maxY[j], minY[j], x[i], x[j], side) ||
                    FourthCondition(maxX[i], minX[j], nextPoint, side)) &&
                    i != j) {
                    let temp = [
                        x[j],
                        minX[j],
                        maxX[j],
                        y[j],
                        minY[j],
                        maxY[j],
                        multiPick[j],
                        multipickAlongWidth[j],
                    ];
                    let tempBool = [r[j], s[j]];
                    [
                        x[j],
                        minX[j],
                        maxX[j],
                        y[j],
                        minY[j],
                        maxY[j],
                        multiPick[j],
                        multipickAlongWidth[j],
                    ] = [
                        x[i],
                        minX[i],
                        maxX[i],
                        y[i],
                        minY[i],
                        maxY[i],
                        multiPick[i],
                        multipickAlongWidth[i],
                    ];
                    [r[j], s[j]] = [r[i], s[i]];
                    [
                        x[i],
                        minX[i],
                        maxX[i],
                        y[i],
                        minY[i],
                        maxY[i],
                        multiPick[i],
                        multipickAlongWidth[i],
                    ] = temp;
                    [r[i], s[i]] = tempBool;
                    swapped = true;
                }
            }
        }
    } while (swapped && loopCount <= maxLoop);
    // Check if we could find a solution within a reasonable amount of tries
    if (loopCount > maxLoop) {
        throw new Error('Could not find solution in reasonable amount of time.');
    }
    // Changing frame for top left
    y = y.map(function (item) {
        return 1 - item / palletLength;
    });
    x = x.map(function (item) {
        return item / palletWidth;
    });
    if (side == 'right') {
        x = x.map(function (item) {
            return item + 1;
        });
    }
    return [x, y, r, s, multiPick, multipickAlongWidth];
}
exports.BoxSort = BoxSort;
var Side;
(function (Side) {
    Side[Side["Left"] = 0] = "Left";
    Side[Side["Right"] = 1] = "Right";
})(Side || (Side = {}));
function marcSort(pConfig, pSide) {
    const lPallet = pConfig.config.pallets[0];
    const lAllBoxes = pConfig.config.boxes;
    const lStack = lPallet.Stack;
    const lLayouts = lPallet.Layouts;
    if (lStack.length === 0 || lLayouts.length === 0)
        return true;
    let xS = [], yS = [];
    let rS = [], sS = [];
    let lMultipick = [];
    let lMultipickAlongWidth = [];
    let lSuccess = true;
    lStack.forEach(function (lLayoutId) {
        const lLayout = lLayouts[lLayoutId];
        if (lLayout.boxPositions.length === 0)
            return;
        const lFirstBoxId = lLayout.boxPositions[0].index;
        const lFirstBox = lAllBoxes[lFirstBoxId];
        const lBoxWidth = lFirstBox.dimensions.width;
        const lBoxLength = lFirstBox.dimensions.length;
        // Clear old coordinates.
        lLayout.boxPositions.forEach(function (lBoxPosition) {
            xS.push(lBoxPosition.position.x);
            yS.push(lBoxPosition.position.y);
            rS.push(lBoxPosition.rotated);
            sS.push(lBoxPosition.spin);
            lMultipick.push(lBoxPosition.multipick || 0);
            lMultipickAlongWidth.push(lBoxPosition.multipickAlongWidth);
        });
        try {
            const [lNewX, lNewY, lNewR, lNewS, lNewMultipick, lNewMultipickAlongWidth,] = BoxSort(xS, yS, rS, sS, lMultipick, lMultipickAlongWidth, lBoxWidth, lBoxLength, lPallet.Dimensions.width, lPallet.Dimensions.length, pSide == Side.Left ? 'left' : 'right');
            // update coordinates in place.
            lLayout.boxPositions.forEach(function (lBoxPosition, lIndex) {
                lBoxPosition.position.x = lNewX[lIndex];
                lBoxPosition.position.y = lNewY[lIndex];
                lBoxPosition.rotated = lNewR[lIndex];
                lBoxPosition.spin = lNewS[lIndex];
                lBoxPosition.multipick = lNewMultipick[lIndex];
                lBoxPosition.multipickAlongWidth = (lNewMultipickAlongWidth[lIndex]);
            });
        }
        catch (_pError) {
            return false;
        }
    });
    return lSuccess;
}
exports.marcSort = marcSort;
